export default [{
  path: '/rcp',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'RCP Historico',
      path: 'historico',
      component: () => import('@/views/rcp/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'RCP' }
        ]
      }
    },
    {
      name: 'RCP Adicionar',
      path: 'add',
      component: () => import('@/views/rcp/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'RCP', path: '/rcp/historico' },
          { name: 'Adicionar' }
        ]
      }
    }
  ]
}]